import { useState, useEffect } from "react";
import "./style.css";
import api from "../../../services/api.js";
import PopUp from "../../../componente/popup/index.jsx";
import PopUpRefazer from "../../../componente/popup/index.jsx";
import { useAppContext } from '../../../context/AppContext.js';
import ModalQualificacao from "react-modal";

function OpeTarefaFinalizada() {
    const { DateTime } = require("luxon");

    // Função para calcular o primeiro dia do mês
    const getFirstDayOfMonth = () => {
        const dt = new Date();
        return `${dt.getFullYear()}-${(dt.getMonth() + 1).toString().padStart(2, "0")}-01`;
    };

    // Função para calcular a data atual
    const getCurrentDate = () => {
        const dt = new Date();
        return `${dt.getFullYear()}-${(dt.getMonth() + 1).toString().padStart(2, "0")}-${dt.getDate().toString().padStart(2, "0")}`;
    };

    const [lista, setlista] = useState([]);
    const [abusca, setabusca] = useState("");

    const [codchecklist, setCodCheckList] = useState(0);
    const [coin, setCoin] = useState(0);
    const [coincalculado, setCoinCalculado] = useState(0);
    const [qualificacao, setQualificacao] = useState(0);

    const [showformqualificacao, setshowformqualificacao] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenRefazer, setIsOpenRefazer] = useState(false);

    const { codassinante, selectedCompany, accessKey } = useAppContext();
    const [dt1, setdt1] = useState(getFirstDayOfMonth);
    const [dt2, setdt2] = useState(getCurrentDate);

    const handleOpen = (cad) => {
        setCodCheckList(cad.codchecklist);
        setCoin(cad.coinssomar);
        setQualificacao(0);
        setIsOpen(true);
    };

    const handleConfirma = () => {
        setIsOpen(false);
        setshowformqualificacao(true);
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    const handleOpenRefazer = (cad) => {
        setCodCheckList(cad.codchecklist);
        setIsOpenRefazer(true);
    };

    const handleConfirmaRefazer = () => {
        setIsOpenRefazer(false);
        InformarRefazer();
    };

    const handleCloseRefazer = () => {
        setIsOpenRefazer(false);
    };

    function closeModalQualificacao() {
        setshowformqualificacao(false);
    }

    function ListarTarefas() {
        api
            .get("/v1/operacoes/tarefafinalizada", {
                params: {
                    busca: abusca,
                    codassinante: codassinante,
                    codempresa: selectedCompany,
                    dt1,
                    dt2
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setlista(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    useEffect(
        function () {
            ListarTarefas();
        },
        [abusca, selectedCompany, dt1, dt2]
    );

    function InformarConclusao() {
        const dt = new Date();
        const date =
            dt.getFullYear() +
            "-" +
            (dt.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            dt.getDate().toString().padStart(2, "0");
        let time =
            dt.getHours().toString().padStart(2, "0") +
            ":" +
            dt.getMinutes().toString().padStart(2, "0");
        let dtcadastro = date + "T" + time;

        if (qualificacao != 0) {
            api
                .put(
                    "/v1/operacoes/tarefafinalizada/concluirtarefa",
                    {
                        dtconclusao: dtcadastro,
                        qualificacao,
                        codchecklist,
                        coinsomar: coin,
                        codempresa: selectedCompany,
                        codassinante
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${accessKey}`,
                        },
                    }
                )
                .then(() => {
                    closeModalQualificacao();
                    ListarTarefas();
                })
                .catch(function (err) {
                    console.log("ops! ocorreu um erro: " + err);
                });
        } else {
            alert("Escolha a nota!");
        }
    }

    function InformarRefazer() {
        api
            .put(
                "/v1/operacoes/tarefafinalizada/refazertarefa",
                {
                    codchecklist
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },
                }
            )
            .then(() => {
                ListarTarefas();
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function FormataDataHora(props) {
        return props
            ? DateTime.fromISO(props)
                .plus({ hours: 3 })
                .toFormat("dd/MM/yyyy HH:mm:ss")
            : null;
    }

    function FormataData(props) {
        return props
            ? DateTime.fromISO(props)
                .plus({ hours: 3 })
                .toFormat("dd/MM/yyyy")
            : null;
    }

    return (
        <>
            <div className="app-container">
                <div className="container-fluid">
                    <div>
                        <div>
                            <PopUp isOpen={isOpen} onClose={handleClose}>
                                <h2>Verificação</h2>
                                <p>Tem certeza que deseja concluir essa tarefa?</p>

                                <div className="row">
                                    <div className="col-12 mt-3 d-flex justify-content-end">
                                        <button
                                            className="btn btn-primary me-2"
                                            onClick={handleConfirma}
                                        >
                                            Sim
                                        </button>
                                        <button className="btn btn-danger" onClick={handleClose}>
                                            Não
                                        </button>
                                    </div>
                                </div>
                            </PopUp>

                            <PopUpRefazer isOpen={isOpenRefazer} onClose={handleCloseRefazer}>
                                <h2>Verificação</h2>
                                <p>Tem certeza que deseja mandar refazer essa tarefa?</p>

                                <div className="row">
                                    <div className="col-12 mt-3 d-flex justify-content-end">
                                        <button
                                            className="btn btn-primary me-2"
                                            onClick={handleConfirmaRefazer}
                                        >
                                            Sim
                                        </button>
                                        <button className="btn btn-danger" onClick={handleCloseRefazer}>
                                            Não
                                        </button>
                                    </div>
                                </div>
                            </PopUpRefazer>
                        </div>

                        <ModalQualificacao
                            isOpen={showformqualificacao}
                            onRequestClose={closeModalQualificacao}
                            className="modal-sm"
                            overlayClassName="modal-overlay"
                            contentLabel="Qualificação"
                        >
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Qualificação</h5>
                                    <button type="button" className="btn-close" onClick={closeModalQualificacao}></button>
                                </div>
                                <div className="modal-body">
                                    {/* Totalizadores */}
                                    <div className="row">
                                        <div className="">
                                            <label className="form-label" htmlFor="coin">Coins Oferecidos</label>
                                            <input className="form-control"
                                                type="text"
                                                name="coin"
                                                id="coin"
                                                value={coin}
                                                onChange={(e) => setCoin(e.target.value)}
                                                disabled
                                            />
                                        </div>
                                    </div>                                    

                                    <div className="row justify-content-center">
                                        <div className="col-auto">
                                            <div className="card mt-2">
                                                <div className="card-body text-center">
                                                    <div className="d-flex flex-wrap gap-2 justify-content-center">
                                                        {['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'].map((val) => (
                                                            <label
                                                                key={val}
                                                                className={`d-flex align-items-center justify-content-center rounded-3 cursor-pointer transition 
                      ${qualificacao === val
                                                                        ? 'bg-primary text-white'
                                                                        : 'bg-light text-dark hover-bg-gray'}`}
                                                                style={{ width: '3rem', height: '3rem', cursor: 'pointer' }}
                                                            >
                                                                <input
                                                                    type="radio"
                                                                    name="qualificacao"
                                                                    value={val}
                                                                    checked={qualificacao === val}
                                                                    onChange={(e) => {setQualificacao(e.target.value); setCoinCalculado((coin * e.target.value)/10)}}
                                                                    className="d-none"
                                                                />
                                                                <span className="fs-4 mb-0">{val}</span>
                                                            </label>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="">
                                            <label className="form-label" htmlFor="coincalculado">Coins creditado</label>
                                            <input className="form-control"
                                                type="text"
                                                name="coincalculado"
                                                id="coincalculado"
                                                value={coincalculado}                                               
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer d-flex align-items-center justify-content-center">
                                    <button type="button" className="btn btn-secondary" onClick={closeModalQualificacao}>
                                        Fechar
                                    </button>
                                    <button type="button" className="btn btn-success" onClick={InformarConclusao}>
                                        Informar
                                    </button>
                                </div>
                            </div>
                        </ModalQualificacao>
                    </div>

                    <div className="row">
                        <h1 className="ms-4">Tarefas Finalizadas</h1>
                        <p className="ms-4">Rotina para receber as tarefas que foram solicitadas aos profissionais da empresa</p>
                        <hr />
                    </div>

                    <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                            <label className="form-label" htmlFor="busca">
                                Busque aqui
                            </label>
                            <input
                                type="text"
                                placeholder="Buscar por: Código, Gestor ou nome do profissional"
                                name="busca"
                                id="busca"
                                className="form-control me-3"
                                value={abusca}
                                onChange={(e) => setabusca(e.target.value)}
                            />
                        </div>

                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                            <label htmlFor="dtlancamento" className="form-label">
                                Dt. Início
                            </label>
                            <input
                                type="date"
                                id="dtlancamento"
                                className="form-control"
                                placeholder="Dt. Lançamento"
                                value={dt1}
                                onChange={(e) => setdt1(e.target.value)}
                            />
                        </div>

                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                            <label htmlFor="dtlancamento" className="form-label">
                                Dt. Término
                            </label>
                            <input
                                type="date"
                                id="dtlancamento"
                                className="form-control"
                                placeholder="Dt. Lançamento"
                                value={dt2}
                                onChange={(e) => setdt2(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="row mt-3">
                        <hr />
                    </div>

                    <div className="row">
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th>Lançamento</th>
                                    <th>Gestor</th>
                                    <th>Profissional</th>
                                    <th>Tipo Periodicidade</th>
                                    <th>Dt. Tarefa</th>
                                    <th>Dt. Tarefa Feita</th>
                                    <th>Tarefa</th>
                                    <th className="acao">Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {lista.map(function (item, index) {
                                    return (
                                        <tr key={index}>
                                            <th>{FormataDataHora(item.dtlancamento)}</th>
                                            <th>{item.gestor}</th>
                                            <th>{item.colaborador}</th>
                                            <th>{item.tipoperiodicidade}</th>
                                            <th>{FormataData(item.dttarefa)}</th>
                                            <th>{FormataData(item.dttarefafeito)}</th>
                                            <th>{item.tarefa}</th>
                                            <th>
                                                <div className="d-flex justify-content-center">
                                                    <button
                                                        className="btn fa-solid fa-refresh"
                                                        onClick={() => handleOpenRefazer(item)}
                                                    ></button>
                                                    <button
                                                        className="btn fa-solid fa-circle-check"
                                                        onClick={() => handleOpen(item)}
                                                    ></button>
                                                </div>
                                            </th>
                                        </tr>
                                    );
                                })}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th colSpan={8}>Quantidade de Registros: {lista.length}</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
}

export default OpeTarefaFinalizada;
